export default "__VITE_ASSET__e4a0e0b7__"